/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DashboardTempoRispostaDTO { 
    /**
     * Media giorni submit→primo esito sulle sole evase; null se nessuna
     */
    media_giorni?: number;
    pratiche_evase?: number;
    in_attesa?: number;
    /**
     * Età in giorni della più vecchia pratica in attesa; null se nessuna
     */
    eta_max_in_attesa_giorni?: number;
}

